module.exports = __webpack_public_path__ + "static/media/user-profile.a318b6cd.svg";